import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { inventoryList } from '../../services/Api';

export const fetchStock = createAsyncThunk(
    'stock/fetchStock',
    async (logistic_id, { getState, rejectWithValue }) => {
        try {
            const { filters } = getState().inventoryList;

            // Prepare parameters conditionally - matching PastTransaction pattern
            const params = {
                sort: 'id',
                sort_order: filters.sorting || 'desc',
                page: filters.page,
                paginate_per_page: filters.paginate_per_page,
                ...(filters.search && { product_name: filters.search }),
                ...(filters.from && { from: filters.from }),
                ...(filters.to && { to: filters.to }),
                ...(filters.status && { status: filters.status })
            };

            const response = await inventoryList(params, logistic_id);
            
            return response;
        } catch (error) {
            throw error;
        }
    }
);

const initialState = {
    stocks: [],
    loading: false,
    error: null,
    pagination: {
        currentPage: 1,
        totalPage: 1,
        showing: 10,
        total: 0
    },
    filters: {
        from: '',
        to: '',
        search: '',
        status: '',
        sorting: 'desc',
        page: "1",
        paginate_per_page: "10"
    }
};

const stockListSlice = createSlice({
    name: 'inventoryList',
    initialState,
    reducers: {
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters: (state) => {
            state.filters = initialState.filters;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStock.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchStock.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.stocks = action.payload.data || [];
                
                if (action.payload.meta) {
                    state.pagination = {
                        currentPage: action.payload.meta.current_page || 1,
                        totalPage: action.payload.meta.last_page || 1,
                        showing: action.payload.meta.per_page || 10,
                        total: action.payload.meta.total || 0
                    };
                }
            })
            .addCase(fetchStock.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.stocks = [];
            });
    }
});

export const { setFilters, resetFilters } = stockListSlice.actions;
export default stockListSlice.reducer;